export const CLICK_NOTIF_VIEW_CART = "ViewCartButton";
export const CLICK_NOTIF_CLOSE_CART = "Close";
